import gql from 'graphql-tag';

export const NUCLEUS_REQUEST_CONTROLLER_STATUS = gql`
  query NucleusRequestControllerStatus($playerId: UUID!, $requestId: String) {
    requestControllerStatus(playerId: $playerId, requestId: $requestId) {
      code
      success
      message
    }
  }
`;